import { B4, Box, Button, L56, L88, Text } from "@adfenix/alexandria";
import { useEffect, useState } from "react";

import { ALERT_MESSAGE_TIMESTAMP } from "utils/constants";
import Cookies from "js-cookie";
import ExclamationCircle from "static/svg/exclamation-circle";
import UilTimes from "@iconscout/react-unicons/icons/uil-times";
import styled from "styled-components";
import { useQuery } from "@tanstack/react-query";
import { getAlert } from "api/services/configService";

const StyledBox = styled(Box)`
  width: 600px;
  position: fixed;
  margin: 0 auto;
  left: 0;
  right: 0;
  bottom: 100px;
  background-color: ${({ theme }) => theme.colors.white};
  border-left: 8px solid ${({ theme }) => L56(theme.colors.warning)};
  ${({ theme }) => theme.borderRadius.m};
  min-height: 80px;
  box-shadow: 0px 1px 6px ${({ theme }) => L88(theme.colors.grey)};
  z-index: 1010;
`;
const AlertMessage = () => {
  const alertTimestampCookie = Cookies.get(ALERT_MESSAGE_TIMESTAMP);
  const [showAlert, setShowAlert] = useState(false);

  const { data: alert } = useQuery(["getAlert"], getAlert);

  useEffect(() => {
    const cookieAlertTimestamp =
      alertTimestampCookie && parseInt(alertTimestampCookie);
    const backendAlertTimestamp = alert?.unixTimestamp;

    if (alert && cookieAlertTimestamp !== backendAlertTimestamp) {
      setShowAlert(true);
      const timeout = setTimeout(() => {
        Cookies.set(ALERT_MESSAGE_TIMESTAMP, alert.unixTimestamp, {
          expires: 1000
        });
      }, 3000);

      return () => clearTimeout(timeout);
    }
  }, [alertTimestampCookie, alert]);

  if (!alert) {
    return null;
  }

  const handleDeleteCookie = () => {
    Cookies.set(ALERT_MESSAGE_TIMESTAMP, alert.unixTimestamp, {
      expires: 1000
    });
    setShowAlert(false);
  };

  return alert && showAlert ? (
    <StyledBox
      p="s"
      display="flex"
      alignItems="center"
      justifyContent="space-between"
    >
      <Box display="flex">
        <Box display="flex" style={{ paddingRight: "12px" }}>
          <ExclamationCircle width={42} color="#fccf21" />
        </Box>
        <Box>
          <B4>{alert.title}</B4>
          <Text as="p">{alert.message}</Text>
        </Box>
      </Box>
      <Button
        variant="text"
        onClick={handleDeleteCookie}
        logLabel="alert-delete-cookie-button"
      >
        <UilTimes size="32px" color="#3d5062" />
      </Button>
    </StyledBox>
  ) : null;
};

export default AlertMessage;
